import { Icon } from '@iconify/react';

function App(props) {

  var clickOption = props.clickOption;
  var options = props.options;

  var selectionRows = options.map((anOption, index)=>{

      return <div key={index} className='col-md-5 cardBlockchain' style={{cursor:'pointer'}} onClick={clickOption(anOption)}> <div> <div className='thumbnailbc'><Icon width = '80' icon={anOption.a} />  </div> <p className='description2'>{anOption.n}</p></div> </div>

  })



  return <div className='row' >
            {selectionRows}

    </div>
//

//
}

export default App;
